import { AppointmentEncounterMode, AppointmentStatus } from '@dreryk/egabinet-appointment-frontend-api';
import { VisitStatus } from '@dreryk/egabinet-visit-frontend-api';

import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';

import { useAppointmentEncounterModeInfo } from './AppointmentEncounterModeInfoItem.hooks';

type AppointmentEncounterModeInfoItemProps = {
   readonly appointmentId: number;
   readonly encounterMode: AppointmentEncounterMode;
   readonly appointmentStatus: AppointmentStatus;
   readonly visitStatus?: VisitStatus;
};

export const AppointmentEncounterModeInfoItem = (props: AppointmentEncounterModeInfoItemProps): JSX.Element => {
   const { content, description, icon, rightContent } = useAppointmentEncounterModeInfo({
      appointmentId: props.appointmentId,
      encounterMode: props.encounterMode,
      appointmentStatus: props.appointmentStatus,
      visitStatus: props.visitStatus,
   });

   return (
      <AppointmentDetailsInfoItem
         testId={'encounterMode'}
         content={content}
         description={description}
         icon={icon}
         rightContent={rightContent}
      />
   );
};
